import { UseMutationOptions } from '@tanstack/react-query';
import useMutation from 'hooks/useMutation';
import { CuredApiPaths } from 'models/enums';
import MutationKeys from './keys';
import { CommunicationType } from 'domains/content/types';

export type CreateDirectMailInput = {
    applicationsAccess: string;
    communicationType: CommunicationType;
    name: string;
    html: string;
    design: any; // TODO: use real type from unlayer
};

const useCreateDirectMail = (mutateOptions: UseMutationOptions<unknown, Error, CreateDirectMailInput>) =>
    useMutation<CreateDirectMailInput>(MutationKeys.CREATE_DIRECT_MAIL, CuredApiPaths.DIRECT_MAIL, mutateOptions);

export default useCreateDirectMail;
